import { render, staticRenderFns } from "./closed.vue?vue&type=template&id=fd366836&scoped=true"
import script from "./closed.vue?vue&type=script&lang=js"
export * from "./closed.vue?vue&type=script&lang=js"
import style0 from "./closed.vue?vue&type=style&index=0&id=fd366836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd366836",
  null
  
)

export default component.exports